import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort } from '@angular/material';
import { ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

import { ListColumn } from './list-column.model';
import { NewHttpDao } from '../utils/new-http-dao';

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleHttpDao. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class DataGeneric extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _properties: string[];

  resultsLength = 0;
  isLoadingResults: boolean;
  isRequestFailed: boolean;
  noResult: boolean;

  constructor(
    protected changeDetectorRefs: ChangeDetectorRef,
    protected _getDataDatabase: NewHttpDao,
    protected _columns: ListColumn[],
    protected _sort: MatSort,
    protected _paginator: MatPaginator,
  ) {
    super();
    this._properties = this._columns.filter(column => column.isModelProperty).map(column => column.property);
  }

  get filter(): string {
    return this._filterChange.value;
  }

  set filter(filter: string) {
    this._filterChange.next(filter);
  }

  get page(): number {
    return this._paginator.pageIndex;
  }

  set page(filter: number) {
    this._paginator.pageIndex = filter;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<any[]> {
    const displayDataChanges = [
      this._sort.sortChange,
      this._paginator.page,
      this._filterChange,
      this._paginator.pageSize
    ];

    // If the user changes the sort order, reset back to the first page.
    this._sort.sortChange.subscribe(() => {
      this._paginator.pageIndex = 0;
    });

    return Observable.merge(...displayDataChanges)
    .startWith(null)
    .switchMap(() => {
      this.isLoadingResults = true;
      this.noResult = false;
      return this._getDataDatabase.getData(this._filterChange.value, this._sort.active, this._sort.direction, this._paginator.pageSize, this._paginator.pageIndex);
    })
    .catch(() => {
      this.isRequestFailed = true;
      return Observable.of(null);
    })
    .map(result => {
      this.isLoadingResults = false;
      if (result.count > 0) {
        this.noResult = false;
        this.isRequestFailed = false;
        this.resultsLength = result.count;
        return this.readDatabaseResult(result);
      } else {
        this.noResult = true;
        this.resultsLength = result.count;
        this.changeDetectorRefs.detectChanges();
        return [];
      }
    });
  }

  disconnect() {}

  protected readDatabaseResult(result: any): any[] {
    return [];
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/list/list-datageneric.ts